import * as AlertDialog from '@radix-ui/react-alert-dialog'
import clsx from 'clsx'
import { CheckCircle, WarningCircle, XCircle } from 'phosphor-react'

import { Button } from '../Button'
import { Medias } from '../../enumns/medias'
import { useMediaQuery } from '../../hooks/useMediaQuery'

type Props = {
  variant: 'success' | 'error'
  isOpen: boolean
  message: string
  buttonLabels: {
    confirm: string
    cancel?: string
  }
  onConfirm: () => void
  onClose: () => void
  onCancel?: () => void
}

export const FeedbackModal = ({
  variant,
  isOpen,
  message,
  buttonLabels,
  onConfirm,
  onClose,
  onCancel,
}: Props) => {
  const isMinimumWidthOfATablet = useMediaQuery(
    `(min-width: ${Medias.MD}px)`
  )

  return (
    <AlertDialog.Root open={isOpen}>
      <AlertDialog.Portal>
        <AlertDialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-50" />

        <AlertDialog.Content className="fixed w-10/12 max-w-xs px-10 py-6 -translate-x-1/2 -translate-y-1/2 bg-white rounded-lg top-1/2 left-1/2 md:max-w-sm md:px-7">
          {isMinimumWidthOfATablet && (
            <AlertDialog.Cancel className="flex justify-end mb-5" asChild>
              <button className="ml-auto" onClick={onClose}>
                <XCircle size={24} className="text-grey-700" />
              </button>
            </AlertDialog.Cancel>
          )}

          <div className="flex flex-col items-center mb-10">
            {variant === 'success' ? (
              <CheckCircle size={78} className="mb-10 text-primary-light" />
            ) : (
              <WarningCircle size={78} className="mb-10 text-primary-light" />
            )}
            <AlertDialog.Title className="font-normal text-center">
              {message}
            </AlertDialog.Title>
          </div>

          <div className="flex gap-2">
            {variant === 'error' && typeof onCancel === 'function' && (
              <div className="flex-1">
                <AlertDialog.Cancel asChild>
                  <Button variant="outline" fullWidth onClick={onCancel}>
                    {buttonLabels.cancel}
                  </Button>
                </AlertDialog.Cancel>
              </div>
            )}

            <div
              className={clsx('flex-1', {
                'md:w-60 md:flex-initial md:mx-auto': variant === 'success',
              })}
            >
              <AlertDialog.Action asChild>
                <Button fullWidth onClick={onConfirm}>
                  {buttonLabels.confirm}
                </Button>
              </AlertDialog.Action>
            </div>
          </div>
        </AlertDialog.Content>
      </AlertDialog.Portal>
    </AlertDialog.Root>
  )
}
